// extracted by mini-css-extract-plugin
export default {"buttons":"FoundContactsWidget_buttons__8SDAI","matchingContacts":"FoundContactsWidget_matchingContacts__eG5jx","row":"FoundContactsWidget_row__9GWbQ"};